import { Timesheet } from '../types';

export const getWeeklyTimesheetWeekStart = (timesheet: Timesheet) => {
  let weekStart = '';
  if (timesheet.weekDates.length && timesheet.holidays.length) {
    const firstWeekStartDate = new Date(timesheet.weekDates[0]);
    const year = timesheet.holidays[0].year || timesheet.weekStart?.split('-')[0];
    const holidayString = `${year}-${timesheet.holidays[0].month}-${timesheet.holidays[0].day}`;
    const firstHolidayDate = new Date(holidayString);
    return firstWeekStartDate < firstHolidayDate ? timesheet.weekDates[0] : holidayString;
  }
  if (timesheet.weekDates.length) {
    weekStart = timesheet.weekDates[0];
  }
  if (timesheet.holidays.length) {
    const year = timesheet.holidays[0].year || timesheet.weekStart?.split('-')[0];
    weekStart = `${year}-${timesheet.holidays[0].month}-${timesheet.holidays[0].day}`;
  }
  return weekStart;
};

export const timesheetMatchesMonthYearFilter = (
  timesheet: Timesheet,
  filterValue: unknown
): boolean => {
  if (filterValue == null || filterValue === '') return true;
  const fv = String(filterValue);
  const weekStartStr = getWeeklyTimesheetWeekStart(timesheet);
  if (!weekStartStr) return false;
  const datePart = weekStartStr.split('T')[0];
  const parts = datePart.split('-');
  if (parts.length < 2) return false;
  const cellYear = Number(parts[0]);
  const cellMonth = Number(parts[1]);
  if (!Number.isFinite(cellYear) || !Number.isFinite(cellMonth)) return false;
  const filterMonth = Number(fv.slice(5, 7));
  const filterYear = Number(fv.slice(0, 4));
  return filterMonth === cellMonth && filterYear === cellYear;
};
